/**
 * The default API base URL for Dynamic apps in production.
 */
export const DEFAULT_API_BASE_URL = 'https://app.dynamicauth.com/api/v0';
